import React from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import { useResponsive } from '../../../../hooks/useResponsive';

interface TwoColumnLayoutProps {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
  leftSpan?: number;
  rightSpan?: number;
  gap?: number;
  className?: string;
}

const StyledRow = styled(Row)<{ $gap: number }>`
  height: 100%;
  margin: 0 -${props => props.$gap / 2}px;
  
  @media (max-width: 1200px) {
    flex-direction: column;
    margin: 0;
  }
`;

const LeftColumn = styled(Col)<{ $gap: number }>`
  padding: 0 ${props => props.$gap / 2}px;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 1200px) {
    padding: 0;
    margin-bottom: ${props => props.$gap}px;
  }
`;

const RightColumn = styled(Col)<{ $gap: number }>`
  padding: 0 ${props => props.$gap / 2}px;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 1200px) {
    padding: 0;
  }
`;

const ColumnContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const TwoColumnLayout: React.FC<TwoColumnLayoutProps> = ({
  leftContent,
  rightContent,
  leftSpan = 16,
  rightSpan = 8,
  gap = 24,
  className = ''
}) => {
  const { isDesktop } = useResponsive();

  return (
    <StyledRow $gap={gap} className={className}>
      <LeftColumn
        xl={leftSpan}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        $gap={gap}
      >
        <ColumnContent>{leftContent}</ColumnContent>
      </LeftColumn>
      
      <RightColumn
        xl={rightSpan}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        $gap={gap}
      >
        <ColumnContent>{rightContent}</ColumnContent>
      </RightColumn>
    </StyledRow>
  );
};







